
import OrganizationApi from 'Api/Organization';

export const GET_START = 'ORGANIZATION.GET_START';
export const GET_SUCCESS = 'ORGANIZATION.GET_SUCCESS';
export const GET_ERROR = 'ORGANIZATION.GET_ERROR';

export const UPDATE_START = 'ORGANIZATION.UPDATE_START';
export const UPDATE_SUCCESS = 'ORGANIZATION.UPDATE_SUCCESS';
export const UPDATE_ERROR = 'ORGANIZATION.UPDATE_ERROR';

export const getOrganization = (orgId, params) => {

    const start = () => ({ type: GET_START,
        orgId });

    const success = response => ({ type: GET_SUCCESS,
        orgId, response });

    const failure = response => ({ type: GET_ERROR,
        orgId, response });

    return (dispatch, getState) => {

        dispatch(start());

        const state = getState();
        const currentUserState = state.User.CurrentUser;

        return OrganizationApi.getOrganization(
            orgId,
            currentUserState.token)
            .then((response) => {

                return dispatch(success(response));

            })
            .catch(error => Promise.reject(dispatch(failure(error))));

    };

};

export const updateOrganization = (orgId, data) => {

    const start = () => ({ type: UPDATE_START,
        orgId });

    const success = response => ({ type: UPDATE_SUCCESS,
        orgId, response });

    const failure = response => ({ type: UPDATE_ERROR,
        orgId, response });

    return (dispatch, getState) => {

        dispatch(start());

        const state = getState();
        const currentUserState = state.User.CurrentUser;

        return OrganizationApi.updateOrganization(
            orgId,
            data,
            currentUserState.token)
            .then((response) => {

                return dispatch(success(response));

            })
            .catch(error => Promise.reject(dispatch(failure(error))));

    };

};

export default {
    getOrganization,
    updateOrganization,
};
